<template>
  <Section>

    <template v-if="content?.type === 'large_image'">

      <FadeIn class="mt-8 lg:mt-16">
        <Container>
          <ImageResponsive
          v-if="content?.image"
          classes="rounded-[20px] md:rounded-[35px]"
          :data="content?.image"
          :lazy="true"
          :xs="12"
          :sm="12"
          :md="12"
          :lg="12"
          :xl="12"
          />
        </Container>
      </FadeIn>

      <FadeIn>
        <Container class="mt-4 lg:mt-8 md:grid md:grid-cols-2 lg:grid-cols-2 gap-6 lg:gap-16">
          
          <div class="md:col-span-1 flex-col flex">
            <h2 class="text-section-title">{{ content.title }}</h2>
            <p class="text-subtitle font-bold mb-6 md:mb-0" v-if="content.subtitle">{{ content.subtitle }}</p>
          </div>

          <div class="md:col-span-1">
            <div
            v-if="content.content" 
            v-html="useSanitize(content.content, currentLocale)"
            v-interpolation
            :class="content.align == 'left' ? 'md:col-start-3 lg:col-start-2' : 'md:col-span-10 md:col-start-3 lg:col-span-8 lg:col-start-3'"
            class="prose color-ol md:col-span-8 lg:col-span-7 relative"
            ></div>
          </div>

        </Container>
      </FadeIn>

    </template>

    <template v-else-if="content?.type === 'left_image'">

      <FadeIn class="max-w-[1080px] mx-auto mt-8 lg:mt-16">
        <Container>
          <div class="max-w-2xl mx-auto text-center">
            <h2 class="text-section-title">{{ content.title }}</h2>
          </div>
        </Container>
        <Container class="gap-8 xl:gap-8 md:grid md:grid-cols-2 lg:grid-cols-2 mt-8 lg:mt-16">
          <div class="md:col-span-1">
            <div class="aspect-square rounded-xl overflow-hidden">
              <ImageResponsive
              v-if="content?.image"
              classes="rounded-[20px] md:rounded-[35px]"
              shape="square"
              :data="content?.image"
              :lazy="true"
              :xs="12"
              :sm="12"
              :md="12"
              :lg="12"
              :xl="12"
              />
            </div>
          </div>
          <div class="md:col-span-1">
            <div
            v-if="content.content" 
            v-html="useSanitize(content.content)"
            v-interpolation
            :class="content.align == 'left' ? 'md:col-start-3 lg:col-start-2' : 'md:col-span-10 md:col-start-3 lg:col-span-8 lg:col-start-3'"
            class="prose color-ol md:col-span-8 lg:col-span-7 relative mt-4 md:mt-0 !md:mt-0"
            ></div>
          </div>
        </Container>
      </FadeIn>

    </template>

    <template v-else> <!-- No image -->
      <FadeIn>
        <Container>
          <div class="max-w-2xl mx-auto md:text-center">
            <h2 class="text-section-title">{{ content.title }}</h2>
            <p class="text-subtitle" v-if="content.subtitle">{{ content.subtitle }}</p>
          </div>
          <div class="max-w-2xl mx-auto mt-8 lg:mt-16">
            <div
            v-if="content.content" 
            v-html="useSanitize(content.content)"
            v-interpolation
            :class="content.align == 'left' ? 'md:col-start-3 lg:col-start-2' : 'md:col-span-10 md:col-start-3 lg:col-span-8 lg:col-start-3'"
            class="prose color-ol md:col-span-8 lg:col-span-7 relative"
            ></div>
          </div>
        </Container>
      </FadeIn>
    </template>

  </section>
</template>

<script setup>
const props = defineProps({
  content: {
    type: Object,
    required: true,
  },
  sectionIndex: {
    type: Number
  }
})

const route = useRoute()
const currentLocale = computed(() => {
  return route.path.startsWith('/nz') ? 'nz' : 'au'
})

</script>